import {brandConfigMap, getBrandConfig} from "@/brand";
import store from "@/store";
import {Brands} from "@/brand/brandConfig";

export function setBrandConfig() {
    const domain = window.origin;
    const urlParams = new URLSearchParams(window.location.search);
    const network = urlParams.get('nt');

    let brandConfig;

    // Check if network parameter exists and set brand config accordingly for World Play
    if (network === 'MTN') {
        brandConfig = getBrandConfig(Brands.MTNWorldPlaySouthAfticaEnglish);
    } else if (network === 'Telkom') {
        brandConfig = getBrandConfig(Brands.TelkomWorldPlaySouthAfticaEnglish);
    } else {
        // Fall back to domain-based configuration if no network parameter
        brandConfig = brandConfigMap.get(domain) ? brandConfigMap.get(domain) : brandConfigMap.get('default');
    }

    store.commit('setBrandConfig', brandConfig);
    console.log(brandConfig);

    const brandStyles = require(`../brand/${brandConfig.brand}/styles/index.js`).styles;
    const brandStyleSheet = document.createElement('style');

    let brandStyleInnerHTML = '';

    brandStyles.backgrounds.forEach((background) => {
        if (brandStyleInnerHTML === '') brandStyleInnerHTML += `.${background.className} { background-color: ${background.colour} }`;
        else brandStyleInnerHTML += ` .${background.className} { background-color: ${background.colour} }`;
    });

    brandStyles.text.forEach((textItem) => {
        brandStyleInnerHTML += ` .${textItem.className} { color: ${textItem.colour} }`;
    });

    // Contextual text overrides applied only for wp-za-en
    if (brandConfig.brand === 'wp-za-en' || brandConfig.brand === 'mtn-wp-za-en' || brandConfig.brand === 'telkom-wp-za-en') {
        if (brandStyles.contextualText && Array.isArray(brandStyles.contextualText)) {
            brandStyles.contextualText.forEach((contextItem) => {
                const parent = contextItem.parentClassName;
                const child = contextItem.className;
                const colour = contextItem.colour;
                const fontWeight = contextItem.fontWeight;
                const fontStyle = contextItem.fontStyle;
                const textDecoration = contextItem.textDecoration;
                let extra = '';
                if (fontWeight) extra += `; font-weight: ${fontWeight}`;
                if (fontStyle) extra += `; font-style: ${fontStyle}`;
                if (textDecoration) extra += `; text-decoration: ${textDecoration}`;
                // Apply when the same element has both classes, or when child is nested within parent
                brandStyleInnerHTML += ` .${parent}.${child}, .${parent} .${child} { color: ${colour}${extra} }`;
            });
        }
    }

    brandStyles.borders.forEach((textItem) => {
        brandStyleInnerHTML += ` .${textItem.className} { border: 1.5px solid ${textItem.colour} }`;
    });

    brandStyleSheet.innerHTML = brandStyleInnerHTML;
    document.body.appendChild(brandStyleSheet);
}
